// Environment Configuration - 直接从环境变量读取
const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || "development";

// 从环境变量获取配置，提供合理的默认值
const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "",
  PRODUCT_ID: process.env.REACT_APP_PRODUCT_ID || "9500",
  PROXY: process.env.REACT_APP_PROXY || "",
  ENV: ENV,
  SDK_API: process.env.NEXT_PUBLIC_API_BASE_URL || "",
};

// 开发环境特殊处理
if (ENV === "development" && !config.PROXY) {
  config.PROXY = "http://localhost";
}

// 辅助函数
export const getEnv = () => config.ENV;
export const getApiBaseUrl = () => config.API_BASE_URL;
export const getProductId = () => {
  const winburstDomain = process.env.REACT_APP_PRODUCT_DOMAIN ?? "";
  const winburstProductId = process.env.REACT_APP_PRODUCT_ID ?? "";
  const otherProductId = process.env.REACT_APP_777_PRODUCT_ID ?? "";

  const currentHostname =
    typeof window !== "undefined" ? window.location.hostname : "";

  // 判断当前域名是否包含 Winburst 品牌域名
  const isWinburst = winburstDomain
    ? currentHostname.includes(winburstDomain)
    : false;

  const productId = isWinburst ? winburstProductId : otherProductId;
  return productId;
};
export const getProxy = () => config.PROXY;

// 导出整个配置对象
export const getConfig = () => config;

// 导出默认配置
export default config;
